const pageNameKey = "customerNamespaceString";

export const customerNamespaceStringEn = {
  [pageNameKey]: {
    linkText: "Namespace",
    copySuccessText: "Namespace copied to clipboard",
    copyErrorText: "Failed to copy namespace to clipboard",
    toolTipText: "Copy Customer Namespace for API access",
  },
};

export const customerNamespaceStringPtBr = {
  [pageNameKey]: {
    linkText: "Namespace",
    copySuccessText: "Namespace copiado para a área de transferência",
    copyErrorText: "Falha ao copiar namespace para a área de transferência",
    toolTipText: "Copiar namespace do cliente para acesso à API",
  },
};

export const customerNamespaceStringDe = {
  [pageNameKey]: {
    linkText: "Namespace",
    copySuccessText: "Namespace in die Zwischenablage kopiert",
    copyErrorText: "Fehler beim Kopieren des Namespace in die Zwischenablage",
    toolTipText: "Kopiere Namespace für API Zugang",
  },
};

export const customerNamespaceStringZhHans = {
  [pageNameKey]: {
    linkText: "命名空间",
    copySuccessText: "命名空间已复制到剪贴板",
    copyErrorText: "无法将命名空间复制到剪贴板",
    toolTipText: "复制客户命名空间以进行API访问",
  },
};

export const customerNamespaceStringIt = {
  [pageNameKey]: {
    linkText: "Namespace",
    copySuccessText: "Namespace copiato negli appunti",
    copyErrorText: "Impossibile copiare il namespace negli appunti",
    toolTipText: "Copia il namespace per l'accesso all'API",
  },
};

export const customerNamespaceStringEs = {
  [pageNameKey]: {
    linkText: "Espacio de nombres",
    copySuccessText: "Espacio de nombres copiado al portapapeles",
    copyErrorText: "No se pudo copiar el espacio de nombres al portapapeles",
    toolTipText:
      "Copiar el espacio de nombres del cliente para el acceso de API",
  },
};

export const customerNamespaceStringNl = {
  [pageNameKey]: {
    copyErrorText: "Fout bij het kopiëren van de namespace naar klembord",
    copySuccessText: "Namespace naar klembord gekopieerd",
    linkText: "Namespace",
    toolTipText: "Kopieer namespace voor API-toegang",
  },
};

export const customerNamespaceStringTr = {
  [pageNameKey]: {
    copyErrorText: "Ad alanı panoya kopyalanamadı",
    copySuccessText: "Ad alanı panoya kopyalandı",
    linkText: "Ad alanı",
    toolTipText: "API erişimi için Müşteri Ad Alanını kopyalayın",
  },
};
